import { AgencyRole } from "../../../../../shared/enum";

export const userHasEditDeletePermission = (role) => {
  return role === AgencyRole.AgencyAdmin || role === AgencyRole.AgencyOwner;
};
